import { Box, Item, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { OptionDropdown } from './OptionDropdown'

interface LevelItemProps {
  name: string
  selectedValue: string
  options: Item[]
  onSelect: (value: string, label: string) => void
  loading?: boolean
}

export const LevelItem = ({ name, selectedValue, options, onSelect, loading }: LevelItemProps) => {
  const emptyOption = (): Item[] => [{ value: '', label: `-- ${i18n.t('common.none')} --` }]

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" maxWidth="s600" alignItems="center">
      <Box paddingTop="s12" width="s300">
        <Text.Normal>{name}</Text.Normal>
      </Box>
      <Box width="s400">
        <OptionDropdown
          name={name}
          selectedValue={selectedValue}
          options={emptyOption().concat(...options)}
          onSelect={onSelect}
          loading={loading}
        />
      </Box>
    </Box>
  )
}
